import clsx from 'clsx';
import { Grid2, Typography, Button, Tooltip } from '@mui/material';

import { ROUTES } from 'core/routing/routes';
import ExperiecerData from './components/ExperiencerData';
import ExperiencesList from './components/ExperiencesList';
import { useStyles } from './styles';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'core/contexts/localization';
import { useState } from 'react';
import { Add, Archive, Unarchive } from '@mui/icons-material';

const ExperiencerHomePage = () => {
    const classes = useStyles();
    const history = useHistory();
    const { t: translate } = useTranslation();

    const [showActive, setShowActive] = useState(true);
    const handleToggleExperiences = () => {
        setShowActive((prev) => !prev);
    };

    return (
        <>
            <Grid2 container className={clsx(classes.container, classes.gridContainer)}>
                <Grid2 size={12} container className={classes.experiencerDataContainer}>
                    <ExperiecerData />
                </Grid2>
            </Grid2>
            <Grid2 container className={classes.container} spacing={3}>
                <Grid2 size={12}>
                    <Grid2 container direction="row" justifyContent="space-between">
                        <Grid2>
                            <Typography variant="h4">{translate('home.experiencer.my_experiences')}</Typography>
                            <Grid2
                                style={{
                                    display: 'flex',
                                    flexDirection: 'flex-start',
                                }}
                            >
                                <Tooltip placement="right" title={showActive ? translate('home.triper.buttons.activeBtn') : translate('home.triper.buttons.archiveBtn')}>
                                    <Button onClick={handleToggleExperiences} className={classes.toggleExperiencesButton}>
                                        {showActive ? <Unarchive /> : <Archive />}
                                    </Button>
                                </Tooltip>
                            </Grid2>
                        </Grid2>

                        <Grid2>
                            <Grid2 container spacing={1} justifyContent="flex-end">
                                <Grid2>
                                    <Button className={classes.newBookingButton} onClick={() => history.push(ROUTES.BOOKINGS.NEW)} startIcon={<Add />}>
                                        {translate('calendar.add_booking')}
                                    </Button>
                                </Grid2>
                                <Grid2>
                                    <Button onClick={() => history.push(ROUTES.EXPERIENCE.EXPERIENCEWIZARD)} className={classes.newExperienceButton} startIcon={<Add />}>
                                        {translate('home.experiencer.buttons.add_experience')}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

                <ExperiencesList showActive={showActive} />
            </Grid2>
        </>
    );
};

ExperiencerHomePage.displayName = 'ExperiencerHomePage';

export default ExperiencerHomePage;
